
import Vue from "vue";
import { mapState } from "vuex";
import { IRootState } from "@/store/types";
import { REFERENCE_DATA } from "@/store/referenceData";
import { ReferenceDataType } from "@/store/referenceData/types";
import { getReferenceDataDescription } from "@/helpers/referenceData";
import { cloneDeep } from "@/helpers/object";
import store from "@/store";

export default Vue.extend({
  data() {
    return {
      showModal: false,
      isLoading: false,
      itemDetails: null,
      headers: [
        { text: "ID", value: "id" },
        { text: "Type", value: "type" },
        { text: "Default Value", value: "defaultValue" }
      ],
      referenceDataType: ReferenceDataType
    };
  },
  computed: {
    pagination: {
      get() {
        return store.state.referenceData.dataTable.pagination;
      },
      set(value: string) {
        this.$store.commit(
          REFERENCE_DATA.NS(REFERENCE_DATA.MUTATIONS.SET_DATA_TABLE_PAGINATION),
          value
        );
      }
    },
    ...mapState({
      items: (state: IRootState) => Object.values(state.referenceData.data)
    })
  },
  methods: {
    onItemClicked(item: any) {
      this.showModal = true;
      this.itemDetails = cloneDeep(item);
    },
    getDescription(code: string, type: any): string {
      if (!code) {
        return "";
      }

      return getReferenceDataDescription(code, type);
    },
    async updateItem() {
      this.isLoading = true;

      await this.$store.dispatch(
        REFERENCE_DATA.NS(REFERENCE_DATA.ACTIONS.UPDATE_REFERENCE_DATA),
        this.itemDetails
      );

      this.showModal = false;
      this.isLoading = false;
    }
  },
  async mounted() {
    this.isLoading = true;

    await this.$store.dispatch(
      REFERENCE_DATA.NS(REFERENCE_DATA.ACTIONS.FETCH_REFERENCE_DATA)
    );

    this.isLoading = false;
  }
});
